var csrf_token,
  railsHost = window.location.protocol + "//" + window.location.hostname,
  ContactForm = {},
  mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/;

// Populating the ContactForm Object
var formElem = document.querySelector('#swag-promotion-form');
ContactForm.formObj = document.getElementById('swag-promotion-form');
ContactForm.formObjError = document.querySelector(".contact-form");
ContactForm.nameField = document.getElementById("form-name");
ContactForm.emailField = document.getElementById("form-email");
ContactForm.titleField = document.getElementById("form-title");
ContactForm.contactField = document.getElementById("form-contact");
ContactForm.companyField = document.getElementById("form-company");
ContactForm.requestType = document.getElementById("request_type");
ContactForm.utf8 = document.getElementById("utf_no");
ContactForm.authenticity = document.getElementById("authenticity_token");


// Success message for user token.
var success = function (data) {
  var dataRequest = bsLib.JSONParse(data.response);
  ContactForm.authenticity.value = dataRequest.csrf_token;
  csrf_token = dataRequest.csrf_token;
};

// Custom Error message for user token.
var error = function () {
  return Messages.salesAndSupportPage.invalidUserToken;
};

// XHR request for user token
bsLib.ajax(
  "GET",
  railsHost + "/user/token.json",
  {},
  false,
  {},
  success,
  error
);

var PartnersContact = (function (csrf_token, ContactForm) {
  return {
    init: init,
    resetForm: resetForm,
    validateFields: _validateFields
  };

  function init() {

    // Request Header
    var form_requestHeader = {
      "X-CSRF-Token": csrf_token,
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8" // Setting content type.
    }

    // Extra Data
    var properties_data = {
      title: document.getElementById("form-title").value,
      contact: document.getElementById("form-contact").value
    }

    // Setting up Form Data
    var form_data = {
      name: document.getElementById("form-name").value,
      email: document.getElementById("form-email").value,
      company: document.getElementById("form-company").value,
      message: JSON.stringify(properties_data),
      authenticity_token: document.getElementById("authenticity_token").value,
      utf8: document.getElementById("utf_no").value,
      request_type: document.getElementById("request_type").value,
      source: "wp_form"
    }

    // Success Function
    var form_success = function (data) {
      var dataRequest = bsLib.JSONParse(data.response);
      if (dataRequest.success === true) {
        var modalContainer = document.querySelector(".thank-you-modal"),
          modal = new tingle.modal({
            onClose: function () {
              modal.destroy();
            }
          });
        modal.setContent(modalContainer.innerHTML);
        modal.open();

        _afterSubmitSuccess();
        _logFormSubmit("FormSubmitSuccess");
      } else {
        console.error("form success failed");
      }

    };

    // Error Function
    var form_error = function () {
      _logFormSubmit("FormSubmitError");
    };

    // xhr request for sending form data
    bsLib.ajax(
      "POST",
      railsHost + "/partners/contact",
      form_data,
      false,
      form_requestHeader,
      form_success,
      form_error
    );

  }

  // Form Validation
  function _validateFields() {
    var formValid = true,
      nameError = document.getElementById("name-error"),
      emailError = document.getElementById("email-error"),
      titleError = document.getElementById("title-error"),
      contactError = document.getElementById("contact-error"),
      companyError = document.getElementById("company-error");

    // Name Field Validation
    if (ContactForm.nameField.value.length === 0) {
      formValid = _showError(
        ContactForm.nameField,
        nameError,
        'name-error',
        Messages.salesAndSupportPage.invalidName
      );
    } else {
      ContactForm.nameField.classList.remove("error-border");
      if (nameError) {
        nameError.remove();
      }
    }

    // Email Field Validation
    if (ContactForm.emailField.value == "") {
      formValid = _showError(
        ContactForm.emailField,
        emailError,
        'email-error',
        Messages.salesAndSupportPage.noemail
      );
    } else if (!ContactForm.emailField.value.match(mailformat)) {
      formValid = _showError(
        ContactForm.emailField,
        emailError,
        'email-error',
        Messages.salesAndSupportPage.invalidEmail
      );
    } else {
      ContactForm.emailField.classList.remove("error-border");
      if (emailError) {
        emailError.remove();
      }
    }

    // Title Field Validation
    if (ContactForm.titleField.value.length === 0) {
      formValid = _showError(
        ContactForm.titleField,
        titleError,
        'title-error',
        Messages.salesAndSupportPage.invalidTitle
      );
    } else {
      ContactForm.titleField.classList.remove("error-border");
      if (titleError) {
        titleError.remove();
      }
    }

    // Contact Field Validation
    if (ContactForm.contactField.value.length === 0) {
      formValid = _showError(
        ContactForm.contactField,
        contactError,
        'contact-error',
        Messages.salesAndSupportPage.noContactNo
      );
    } else {
      ContactForm.contactField.classList.remove("error-border");
      if (contactError) {
        contactError.remove();
      }
    }

    // Company Field Validation
    if (ContactForm.companyField.value.length === 0) {
      formValid = _showError(
        ContactForm.companyField,
        companyError,
        'company-error',
        Messages.salesAndSupportPage.noCompanyName
      );
    } else {
      ContactForm.companyField.classList.remove("error-border");
      if (companyError) {
        companyError.remove();
      }
    }

    return formValid;
  }

  function _showError(fieldName, fieldError, errorName, errorMessage) {
    inlineError.showError(fieldName, fieldError, errorName, errorMessage);
  }

  function _afterSubmitSuccess() {
    // Hide thank you modal, reset form
    resetFormTimeout = setTimeout(function () {
      resetForm();
    }, 4000);
  }

  function resetForm() {
    clearTimeout(resetFormTimeout);
    ContactForm.formObj.reset(); //Reset form
  }

  function _logFormSubmit(status) {
    if (status == "FormSubmitSuccess") {
      ga('browserstack.send', 'event', {
        'eventCategory': 'Browserstack Swag Promotion Form', 'eventAction': 'CtaClick', 'eventLabel': 'Submit'
      });
    }
  }
})(csrf_token, ContactForm);

formElem.addEventListener("submit", function (e) {
  e.preventDefault();

  if (!PartnersContact.validateFields()) {
    return false;
  }

  PartnersContact.init();
  return false;
});